import { css } from 'styled-components';

import { SizeUnit } from '@utils/types';

type WithWidthProp = {
  width?: SizeUnit;
};

export const widthMixin = ({ width }: WithWidthProp) =>
  width
    ? css`
        width: min(${width}, 100vw);
      `
    : null;
